import Moment from 'react-moment';

const NiceSignBrightness = (props) => {

const brightness = props.children
const percent = (brightness / 255 * 100).toFixed(2) + "%"

return (
      percent
  )
}

export default NiceSignBrightness;